import React from 'react';
import PropTypes from 'prop-types';
import {RUOLI} from "../../../applicationConf";

const SceltaProfilo = ({profiliDisponibili, chooseRole}) => (

    <div className='pb-5 pt-5 animate__animated animate__fadeIn' data-test='component-sceltaProfilo'>
        <div className='card scelta__ruoli'>
            <div className='card-header card-title bg-primary text-white'>
                <h4>Scelta Profilo</h4>
            </div>
            <div className='card-body'>
                <div className='d-flex justify-content-center'>
                    <select name="profili"
                            id="profili"
                            defaultValue='none'
                            className='form-control'
                            onChange={chooseRole}
                    >
                        <option className='text-muted' value="none" disabled >-- Nessuno --</option>
                        {profiliDisponibili.map(p => <option value={p.nome}
                                                             key={Math.random().toString(33).replace('0.', '')}
                                                             className='text-capitalize'>{RUOLI[p.nome.toUpperCase()].RUOLO}</option>)}
                    </select>
                </div>
            </div>
        </div>
    </div>
);

SceltaProfilo.propTypes = {
    profiliDisponibili: PropTypes.arrayOf(
        PropTypes.shape({ name: PropTypes.string })
    ),
    chooseRole: PropTypes.func
};


export default SceltaProfilo;









